export const useActiveCategory = createSharedComposable(() => {
  const activeCategoryId = ref<string | null>(null);

  return {
    activeCategoryId,
    setActiveCategoryId: (id: string | null) => (activeCategoryId.value = id),
  };
});
